<script setup lang="ts">
  import type { PropType } from 'vue'
  import { HLHeaderLite } from '@platform-ui/highrise'

  defineProps({
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      default: 'lg',
    },
  })

  defineEmits(['update:close'])
</script>

<template>
  <HLHeaderLite :size="size" v-bind="$attrs" @update:close="$emit('update:close')">
    <template v-if="$slots['header-title']" #header-title>
      <slot name="header-title" />
    </template>
    <template v-if="$slots['header-subtitle']" #header-subtitle>
      <slot name="header-subtitle" />
    </template>
    <template v-if="$slots['header-icons']" #header-icons>
      <slot name="header-icons" />
    </template>
    <template v-if="$slots['header-content-right']" #header-content-right>
      <slot name="header-content-right" />
    </template>
  </HLHeaderLite>
</template>
